import { useQuery } from "@tanstack/react-query";
import { fetchStreams } from "api/streams";
export const STREAMS_QUERY_KEY = ["streams", "all"];
const useAllStreams = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: STREAMS_QUERY_KEY,
    queryFn: fetchStreams
  });
  return {
    data,
    isLoading,
    refetch
  };
};
export default useAllStreams;
